export default function Company() {
  return (
    <section id="company" className="relative py-16 md:py-32 bg-white overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"></div>
        <div className="absolute top-40 left-0 w-64 h-64 bg-amber-400/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-0 w-80 h-80 bg-slate-100 rounded-full blur-3xl"></div>
        {/* Dot pattern */}
        <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, #1e293b 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-12 h-px bg-amber-400"></div>
            <p className="text-amber-600 text-sm font-medium tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              COMPANY INFO
            </p>
            <div className="w-12 h-px bg-amber-400"></div>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            会社情報
          </h2>
        </div>

        {/* Company Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {/* Left - Company Details */}
          <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-6 md:p-10 border border-slate-100 shadow-lg shadow-slate-100/50">
            {/* Gold accent */}
            <div className="flex items-center gap-3 mb-10">
              <div className="w-1 h-8 bg-gradient-to-b from-amber-400 to-amber-500 rounded-full"></div>
              <h3 className="text-lg font-bold text-slate-900">基本情報</h3>
            </div>

            <div className="space-y-0">
              {/* Company Name */}
              <div className="flex items-start gap-6 py-6 border-b border-slate-100 group hover:bg-slate-50/50 -mx-4 px-4 rounded-lg transition-colors">
                <div className="w-28 flex-shrink-0">
                  <p className="text-xs font-bold text-slate-400 tracking-wider">会社名</p>
                </div>
                <div className="flex-1">
                  <p className="text-slate-800 font-medium">Jon&Gコンサルティング株式会社</p>
                </div>
              </div>

              {/* Representative */}
              <div className="flex items-start gap-6 py-6 border-b border-slate-100 group hover:bg-slate-50/50 -mx-4 px-4 rounded-lg transition-colors">
                <div className="w-28 flex-shrink-0">
                  <p className="text-xs font-bold text-slate-400 tracking-wider">代表者</p>
                </div>
                <div className="flex-1">
                  <p className="text-slate-800 font-medium">代表取締役　岡 和明</p>
                </div>
              </div>

              {/* Location */}
              <div className="flex items-start gap-6 py-6 border-b border-slate-100 group hover:bg-slate-50/50 -mx-4 px-4 rounded-lg transition-colors">
                <div className="w-28 flex-shrink-0">
                  <p className="text-xs font-bold text-slate-400 tracking-wider">所在地</p>
                </div>
                <div className="flex-1">
                  <p className="text-slate-800 font-medium">〒104-0061</p>
                  <p className="text-slate-600 text-sm mt-1">東京都中央区銀座一丁目22番11号<br />銀座大竹ビジデンス 2F</p>
                </div>
              </div>

              {/* Business */}
              <div className="flex items-start gap-6 py-6 group hover:bg-slate-50/50 -mx-4 px-4 rounded-lg transition-colors">
                <div className="w-28 flex-shrink-0">
                  <p className="text-xs font-bold text-slate-400 tracking-wider">事業内容</p>
                </div>
                <div className="flex-1">
                  <ul className="space-y-2 text-slate-600 text-sm">
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-amber-400 rounded-full"></span>
                      各種コンサルティング（人事組織・財務・営業）
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-amber-400 rounded-full"></span>
                      助成金活用診断・提案
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-amber-400 rounded-full"></span>
                      人材開発助成金対応 AI研修
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-amber-400 rounded-full"></span>
                      セールス・キャリアコーチング
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Map & Access */}
          <div className="space-y-6">
            {/* Map */}
            <div className="relative rounded-2xl overflow-hidden shadow-lg shadow-slate-200/50 border border-slate-100">
              <div className="w-full h-80">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.0234567890123!2d139.7658!3d35.6719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDQwJzE4LjgiTiAxMznCsDQ1JzU2LjkiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Jon&Gコンサルティング株式会社 所在地"
                ></iframe>
              </div>
              {/* Map overlay badge */}
              <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-slate-100">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse"></div>
                  <span className="text-xs font-medium text-slate-700">銀座オフィス</span>
                </div>
              </div>
            </div>

            {/* Access Info Cards */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-xl p-6 text-white group hover:shadow-xl transition-shadow">
                <div className="w-10 h-10 bg-amber-400/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-amber-400/30 transition-colors">
                  <i className="ri-subway-line text-amber-400"></i>
                </div>
                <p className="text-xs text-slate-400 mb-1">最寄り駅</p>
                <p className="text-sm font-medium">銀座一丁目駅</p>
                <p className="text-xs text-slate-400 mt-1">徒歩3分</p>
              </div>
              <div className="bg-gradient-to-br from-amber-400 to-amber-500 rounded-xl p-6 text-slate-900 group hover:shadow-xl transition-shadow">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-white/30 transition-colors">
                  <i className="ri-time-line text-slate-900"></i>
                </div>
                <p className="text-xs text-slate-700 mb-1">営業時間</p>
                <p className="text-sm font-bold">平日 9:00 - 18:00</p>
                <p className="text-xs text-slate-700 mt-1">土日祝休み</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
